import { useMemo } from "react";
import { FinancialAccount } from "@common/types/financialAccount";
import { useFinancialAccounts } from "@hooks/useFinancialAccounts";

export function useFinancialAccountsById(): ReadonlyMap<
    number,
    FinancialAccount
> {
    const financialAccounts = useFinancialAccounts();
    return useMemo(
        () =>
            new Map(financialAccounts.map((account) => [account.id, account])),
        [financialAccounts],
    );
}
